import EnquiryEditor, { type EnquiryEditorProps } from "./editor";

export default function Completion(props: EnquiryEditorProps) {
  return <EnquiryEditor {...props} />;
}
